import { defineComponent as a, resolveComponent as t, openBlock as i, createBlock as p, withCtx as r, createVNode as d, renderSlot as u, createCommentVNode as s } from "vue";
import l from "../VContentChip/VContentChip.js";
import m from "../VLink/VLink.js";
import { _ as c } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useSpacingClass.js";
import "../../../utils/isExternalUrl.js";
const f = a({
  name: "VTargetContentChip",
  components: { VLink: m, VContentChip: l },
  props: {
    target: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: "grey-200",
      validator: (e) => ["grey-200", "green-deep", ""].includes(e)
    },
    size: {
      type: String,
      default: "m",
      validator: (e) => ["s", "m"].includes(e)
    },
    router: {
      type: Object,
      required: !0,
      default: void 0
    }
  }
});
function g(e, C, k, V, h, _) {
  const o = t("VContentChip"), n = t("VLink");
  return e.target ? (i(), p(n, {
    key: 0,
    href: e.target,
    target: e.target,
    router: e.router
  }, {
    default: r(() => [
      d(o, {
        backgroundColor: e.backgroundColor,
        size: e.size
      }, {
        default: r(() => [
          u(e.$slots, "default")
        ]),
        _: 3
      }, 8, ["backgroundColor", "size"])
    ]),
    _: 3
  }, 8, ["href", "target", "router"])) : s("", !0);
}
const L = /* @__PURE__ */ c(f, [["render", g]]);
export {
  L as default
};
